'use client';
import { withAuthenticationRequired } from '@/auth';
import { FullPageLoader } from '@/components/full-page-loader/full-page-loader';
import dynamic from 'next/dynamic';

const Intro = dynamic(() => import('../../components/my-experience/prefill/steps/intro'), {
  ssr: false,
});

const AuthIntroPage = withAuthenticationRequired(Intro, {
  onRedirecting: () => <FullPageLoader>Redirecting to login page...</FullPageLoader>,
});

export default AuthIntroPage as any;
